/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookingWithoutEvent } from './BookingWithoutEvent';
import type { EventLogEntry } from './EventLogEntry';
export type BookedEvent = {
    id: number;
    status: BookedEvent.status;
    notice: string | null;
    booking?: BookingWithoutEvent | null;
    log: Array<EventLogEntry>;
};
export namespace BookedEvent {
    export enum status {
        OPEN = 'open',
        BOOKED = 'booked',
        ASSIGNED = 'assigned',
        APPROVED = 'approved',
        CANCELLED = 'cancelled',
        REJECTED = 'rejected',
        OUTAGE = 'outage',
        SKIPPED = 'skipped',
        MOVE_REQUESTED = 'move-requested',
    }
}

